import { CountriesEffects } from './countries.effect';
import { RouterEffects } from './router.effect';
import { UserEffects } from './user.effect';
import { UsersEffects } from './users.effect';

export const effects: any[] = [RouterEffects, UserEffects, UsersEffects, CountriesEffects];

export * from './router.effect';
